import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import projectsReducer from './slices/projectsSlice';
import sprintsReducer from './slices/sprintsSlice';
import tasksReducer from './slices/tasksSlice';
import usersReducer from './slices/usersSlice';
import libraryReducer from './slices/librarySlice';
import executivePlanReducer from './slices/executivePlanSlice';
import reportingReducer from './slices/reportingSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    projects: projectsReducer,
    sprints: sprintsReducer,
    tasks: tasksReducer,
    users: usersReducer,
    library: libraryReducer,
    executivePlan: executivePlanReducer,
    reporting: reportingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
